/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetTaskListFiltersParams,
  GetTaskListFiltersResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Task list filters
 * @summary Get All filters for task list
 */
export const getTaskListFilters = (params?: GetTaskListFiltersParams, signal?: AbortSignal) => {
  return customInstance<GetTaskListFiltersResponseResponse>({
    url: `/bm-declaration-service/v1/task/list/filters`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetTaskListFiltersQueryKey = (params?: GetTaskListFiltersParams) => {
  return [`/bm-declaration-service/v1/task/list/filters`, ...(params ? [params] : [])] as const;
};

export const getGetTaskListFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskListFilters>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetTaskListFiltersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskListFilters>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskListFiltersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskListFilters>>> = ({ signal }) =>
    getTaskListFilters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskListFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTaskListFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaskListFilters>>
>;
export type GetTaskListFiltersQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get All filters for task list
 */
export const useGetTaskListFilters = <
  TData = Awaited<ReturnType<typeof getTaskListFilters>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetTaskListFiltersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskListFilters>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTaskListFiltersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
